import React, { Component } from 'react'
import { Icon } from 'antd';
import { connect } from 'react-redux';

import { get_employee } from './../actions/print.action';

// Styles
import './../style.css';

class ProfilePrint extends Component {

    constructor( props ){
        super( props );

        this.state = {
             data: []
        }

    }

    componentWillMount(){
        this.props.get_employee( this.props.match.params.id );
    }

    componentWillReceiveProps( nextProps ){

        if( nextProps.print.length !== 0 ){

            this.setState({
                data: nextProps.print.OUTPUT.DATA
            })

            setTimeout(()=>{ window.print(); },500)
            
        }

    }

    render() {
        return (
            <div className="print_wrapper">
                
                <table width="100%">

                    <thead>
                        <tr>
                            <th colSpan="2">
                                <span className="print_logo"></span>
                                <span className="jgroup_logo"></span>
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        
                        <tr><td colSpan="2">&nbsp;</td></tr>

                        <tr>
                            <td width="80%" valign="top">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td colSpan="2"><span className="text_field"><em>Employee Name: </em><span style={{fontSize: '18px' }}>{ this.state.data.full_name }</span></span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Designation: </em>{ this.state.data.designation_name }</span></td>
                                            <td width="50%"><span className="text_field"><em>Department: </em>{ this.state.data.department_name }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Reporting To: </em>{ this.state.data.reporting_manager }</span></td>
                                            <td width="50%"><span className="text_field"><em>Date of Joining: </em>{ this.state.data.date_of_joining }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Visa Sponsorship: </em>{ this.state.data.visa_sponsor }</span></td>
                                            <td width="50%"><span className="text_field"><em>Employee Type: </em>{ this.state.data.employee_type }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Employee status: </em>{ this.state.data.employee_status }</span></td>
                                            <td width="50%"><span className="text_field"><em>Role: </em>{ this.state.data.role }</span></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                            <td width="20%">
                                <span className="pic_field">
                                    <div className="img_thumb">
                                        <div className="img_thumb_inner">
                                            <img src={ this.state.data.picture } />
                                        </div>
                                    </div>
                                </span>
                            </td>
                        </tr>

                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr><td colSpan="2"><h3 className="print_sub_head"><Icon type="user" /> Personal Data</h3></td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>

                        <tr>
                            <td colSpan="2">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Work Phone:</em>{ this.state.data.work_phone }</span></td>
                                            <td width="50%"><span className="text_field"><em>Mobile Phone: </em>{ this.state.data.mobile_phone }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Email:</em>{ this.state.data.user_email }</span></td>
                                            <td width="50%"><span className="text_field"><em>Other Email: </em>{ this.state.data.other_email }</span></td>
                                        </tr>

                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Date of Birth:</em>{ this.state.data.birth_date }</span></td>
                                            <td width="50%"><span className="text_field"><em>Gender: </em>{ this.state.data.gender }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Marital Status:</em>{ this.state.data.marital_status }</span></td>
                                            <td width="50%"><span className="text_field"><em>Religion: </em>{ this.state.data.religion }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Mother Name:</em>{ this.state.data.mother }</span></td>
                                            <td width="50%"><span className="text_field"><em>Father Name: </em>{ this.state.data.father }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Country:</em>{ this.state.data.country }</span></td>
                                            <td width="50%"><span className="text_field"><em>State: </em>{ this.state.data.states }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%" valign="top"><span className="text_field adrs"><em>Current Address:</em><span>{ this.state.data.address }</span></span></td>
                                            <td width="50%" valign="top"><span className="text_field adrs"><em>Home Country Address: </em><span>{ this.state.data.homeaddress }</span></span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em className="small">Emergency Contact Person Name #1:</em>{ this.state.data.emergency_contact_name_1 }</span></td>
                                            <td width="50%"><span className="text_field"><em className="small">Emergency Contact Person Name #2: </em>{ this.state.data.emergency_contact_name_2 }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em className="small">Relationship #1:</em>{ this.state.data.emergency_contact_relation_1 }</span></td>
                                            <td width="50%"><span className="text_field"><em className="small">Relationship #2: </em>{ this.state.data.emergency_contact_relation_2 }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em className="small">Contact Number #1:</em>{ this.state.data.emergency_contact_1 }</span></td>
                                            <td width="50%"><span className="text_field"><em className="small">Contact Number #2: </em>{ this.state.data.emergency_contact_2 }</span></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr><td colSpan="2"><h3 className="print_sub_head"><i className="flight" /> Passport & Visa Info</h3></td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>

                        <tr>
                            <td colSpan="2">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Passport Number: </em>{ this.state.data.passport_number }</span></td>
                                            <td width="50%"><span className="text_field"><em>Place of Passport Issue: </em>{ this.state.data.passport_place_issue }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Date of Passport Issue: </em>{ this.state.data.passport_issue }</span></td>
                                            <td width="50%"><span className="text_field"><em>Date of Passport Expiry: </em>{ this.state.data.passport_expiry }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Visa UID#: </em>{ this.state.data.visa_uid }</span></td>
                                            <td width="50%"><span className="text_field"><em>Visa Issue Date: </em>{ this.state.data.visa_issue_date }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Date of Visa Expiry: </em>{ this.state.data.visa_expiry_date }</span></td>
                                            <td width="50%"></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr><td colSpan="2"><h3 className="print_sub_head"><Icon type="idcard" /> &nbsp;Emirates & Tecom ID Info</h3></td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>

                        <tr>
                            <td colSpan="2">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Emirate ID#: </em>{ this.state.data.emirates_id }</span></td>
                                            <td width="50%"><span className="text_field"><em>Date of Expiry: </em>{ this.state.data.emirates_expiry }</span></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>


                        <tr>
                            <td colSpan="2">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Tecom ID#: </em>{ this.state.data.tecom_id }</span></td>
                                            <td width="50%"><span className="text_field"><em>Date of Expiry: </em>{ this.state.data.tecom_expiry }</span></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                        <tr><td colSpan="2">&nbsp;</td></tr>
                        <tr><td colSpan="2"><h3 className="print_sub_head"><Icon type="bank" /> Bank Info</h3></td></tr>
                        <tr><td colSpan="2">&nbsp;</td></tr>

                        <tr>
                            <td colSpan="2">

                                <table width="100%">
                                    <tbody>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>Bank Name: </em>{ this.state.data.bank_name }</span></td>
                                            <td width="50%"><span className="text_field"><em>Account Name: </em>{ this.state.data.bank_acc_name }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%"><span className="text_field"><em>IBAN Number: </em>{ this.state.data.bank_iban }</span></td>
                                            <td width="50%"><span className="text_field"><em>Account Number: </em>{ this.state.data.bank_acc_number }</span></td>
                                        </tr>
                                        <tr>
                                            <td width="50%" valign="top"><span className="text_field adrs"><em>Swift Code: </em>{ this.state.data.bank_swift }</span></td>
                                            <td width="50%" valign="top"><span className="text_field adrs"><em>Bank Address: </em>{ this.state.data.bank_address }</span></td>
                                        </tr>
                                    </tbody>
                                </table>

                            </td>
                        </tr>

                    </tbody>

                </table>


            </div>
        )
    }
}

function mapStatetoProps( state ){
    return {
        print: state.print
    }
}

export default connect( mapStatetoProps, { get_employee } )( ProfilePrint );



// WEBPACK FOOTER //
// ./src/pages/prints/profile/index.js